import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AuthProvider } from './services/AuthContext';
import { LanguageProvider } from './services/LanguageContext';
import './index.css';
import '../src/fonts.css';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
